<template>
  <div class="card overflow-hidden" v-if="isSendEmail == 1">
    <div class="bg-primary bg-soft">
      <div class="row">
        <div class="col-7">
          <div class="text-primary p-4">
            <h5 class="text-primary" style="font-weight: 600">
              Verifikasi Email
            </h5>
            <p>
              Cek email anda, kami mengirim kode verifikasi di
              <br class="mb-1" />
              <span class="font-weight-bold text-primary">{{
                emailForgot_
              }}</span>
            </p>
          </div>
        </div>
        <div class="col-5 align-self-end">
          <!-- <img
                      src="../../assets/upload/office.png"
                      alt="..."
                      id="pictureOffice"
                      class="img-fluid"
                      style="margin-left: 72%; margin-top: -100px"
                    /> -->
        </div>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="auth-logo">
        <a href="#" class="auth-logo-light">
          <div class="avatar-md profile-user-wid mb-4">
            <span class="avatar-title rounded-circle bg-light">
              <img
                src="../../assets/upload/market.png"
                alt="..."
                class="rounded-circle"
                height="40"
              />
            </span>
          </div>
        </a>
      </div>
      <div class="p-2">
        <form class="form-horizontal" @submit.prevent="_sendVerification">
          <div class="mb-3">
            <label for="email" class="form-label">Kode Verifikasi</label>
            <div class="row">
              <div v-for="(el, i) in 6" :key="i" class="col-md-2">
                <input
                  maxlength="1"
                  class="form-control text-center input-verification"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                  :id="'code' + (i + 1)"
                />
              </div>
            </div>
            <div class="text-center">
              <!-- {{ countDown }} -->
              <span class="small">Tidak menerima kode?</span>
              <br />
              <a href="#" class="small text-primary">Kirim ulang ></a>
            </div>
          </div>

          <div class="mt-3 d-grid">
            <button type="button" class="btn btn-primary btn-xl" @click="_sendCode">
              <span style="font-size: 14px">Next</span>
              <span
                id="spinnerSpan"
                class="spinner-border d-none spinner-border-sm ml-1"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters } from 'vuex';
export default {
  props: {
    isSendEmail: Number,
    emailForgot_: String,
    _sendVerification: Function,
  },
  computed:{
    ...mapGetters(["codeForgot_"]),
    ...mapGetters(["getCode_"]),
  },
  data() {
    return {
      countDown: 60,
      verification:{
        email:'',
        code:''
      }
    };
  },
  created() {
    this.countDownTimer();
  },  
  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    _sendCode(){
      const _getEmail = localStorage.getItem("_localemail");
      let code =''
        for (let i = 0; i < 6; i++) {
          code += $(`#code${i+1}`).val()
        }
      this.verification.code = code 
      this.verification.email = _getEmail
      this.$store.dispatch('_setCode',this.verification).then(() =>{
        if(this.codeForgot_.code == 400){
          this.$toast.error(this.codeForgot_.message)
          localStorage.removeItem('isSendCode')
        } else {
          this.$toast.success(this.codeForgot_.message)
          localStorage.setItem('isSendCode', true)
          localStorage.setItem('codeNum', this.getCode_)
          this.next()
        }
      })
    },
    next(){
      this.$router
        .replace({ path: "forgot", query: { _stepforgot: 2 } })
        .catch(() => {});
    }
  },
};
</script>

<style scoped>
.input-verification {
  border-bottom: 1px solid !important;
  background-color: #f8f8fb !important;
}

.input-verification:focus,
.input-verification:hover {
  border-bottom: 3px solid !important;
  background-color: #f8f8fb !important;
}

.confirmation_code_span_cell {
  display: table-cell;
  font-weight: 700;
  font-size: 2rem;
  text-align: center;
  padding: 0 0.5rem;
  width: 2rem;
}
.is-invalid {
  border: 1px solid #dc3545 !important;
}
.pt-sm-5 {
  padding-top: 3rem !important;
}

.my-5 {
  margin-top: 8rem !important;
  margin-bottom: 3rem !important;
}

.card {
  margin-bottom: 24px;
  -webkit-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}

.overflow-hidden {
  overflow: hidden !important;
}

.card {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid #f6f6f6;
  border-radius: 0.25rem;
}

.btn-xl {
  height: 80%;
}
.bg-primary.bg-soft {
  background-color: rgba(85, 110, 230, 0.25) !important;
}

.row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) / -2);
  margin-left: calc(var(--bs-gutter-x) / -2);
}

.row > * {
  position: relative;
}

.col-7 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 58.33333%;
}

.h5,
h5 {
  font-size: 1.01563rem;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

.card {
  word-wrap: break-word;
}

.row > * {
  position: relative;
}

.align-self-end {
  -ms-flex-item-align: end !important;
  align-self: flex-end !important;
}

.col-5 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 41.66667%;
}

.row > * {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) / 2);
  padding-left: calc(var(--bs-gutter-x) / 2);
  margin-top: var(--bs-gutter-y);
}

.img-fluid {
  max-width: 100px;
  height: auto;
}

.pt-0 {
  padding-top: 0 !important;
}

.card-body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem 1.25rem;
  padding-top: 1.25rem;
}

.card {
  word-wrap: break-word;
}

.auth-logo .auth-logo-dark {
  display: block;
}

a,
button {
  outline: 0 !important;
}

a {
  text-decoration: none !important;
}

a {
  color: #556ee6;
  text-decoration: none;
}

.profile-user-wid {
  margin-top: -26px;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.avatar-title {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #556ee6;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 500;
  height: 100%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100%;
}

.rounded-circle {
  border-radius: 50% !important;
}

.bg-light {
  background-color: #eff2f7 !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

img,
svg {
  vertical-align: middle;
}

.p-2 {
  padding: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.form-label {
  margin-bottom: 0.5rem;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

label {
  display: inline-block;
}

.form-control {
  border: 0;
  /* padding: 15px 25px; */
  margin-bottom: 20px;
  background-color: #fff !important;
  color: #8898aa !important;
  min-height: 45px;
  font-size: 13px;
  /* line-height: 15; */
  font-weight: normal;
  /* color: black !important; */
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-check {
  position: relative;
  text-align: left;
}

.form-check {
  display: block;
  min-height: 1.21875rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check-input[type="checkbox"] {
  border-radius: 0.25em;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  -webkit-transition: background-color 0.15s ease-in-out,
    background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out,
    background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out,
    background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out,
    background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

label {
  display: inline-block;
}

.mt-3 {
  margin-top: 1rem !important;
}

.d-grid {
  display: grid !important;
}

.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.btn-primary {
  color: #fff;
  background-color: #556ee6 !important;
  border-color: #556ee6 !important;
}

.btn-success {
  color: #fff;
  background-color: rgb(52, 195, 143) !important;
  border-color: rgb(52, 195, 143) !important;
}

.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),
.input-group:not(.has-validation)
  > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled),
button:not(:disabled) {
  cursor: pointer;
}

.btn-light {
  color: #000;
  background-color: #eff2f7;
  border-color: #eff2f7;
}
</style>